(() => {
  const campingEventButton = '.camping-event-button';

  const init = () => {
    $('body')
      .on('click', campingEventButton, showCampingEventModal);
  }

  const showCampingEventModal = e => {
    e.preventDefault();
    const $element = $(e.currentTarget);
    const selectedCampingEventId = $element[0].dataset.campingEventId;
    const campingEvents = $('#data-camping-event').data('camping-events');

    campingEvents.forEach(event => {
      if (event.id == selectedCampingEventId) {
        $('.camping-event-detail-modal').empty();
        $('.camping-event-detail-modal').append(buildCampingEventModal(event));
      }
    })
  }

  const buildCampingEventModal = (event) => {
    const taxRate = $('#data-tax').data('tax-rate');
    const adultCharge = event.adult_charge * (1 + taxRate)
    const kidsCharge = event.kids_charge * (1 + taxRate)
    var campingEvent =
    `
      <div class="modal-body">
        <div class="title">${event.title}</div>
        <div class="price-block">
          <div class="block-left">
            <img src=${event.image.admin_show_thumb.url}>
          </div>
          <div class="block-right">
            <div class="price-block">
              <span>大人</span>
              <span class="price">${adultCharge.toLocaleString()}</span>
              <span class="unit">円</span>
              <span class="tax">（税込）</span>
            </div>
            <div class="price-block">
              <span>子ども</span>
              <span class="price">${kidsCharge.toLocaleString()}</span>
              <span class="unit">円</span>
              <span class="tax">（税込）</span>
            </div>
          </div>
        </div>
        <div class="description modal-description camping-event-model-content"><p>${event.content}</p></div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-success inversion btn-block" data-dismiss="modal">閉じる</button>
      </div>
    `
    return campingEvent;
  }
  $(init);
})();

